import { TAccount } from '@sga/shopify-payments-types'

import { useAuth } from '../components/AuthContext'

export function useAccount<T extends TAccount = TAccount>() {
  return useAuth()!.account as T
}
